export enum Permission {
  SearchDNASamples = "SearchDNASamples",
  ViewDNASamples = "ViewDNASamples",
  CreateSampleCorrection = "CreateSampleCorrection",
  CreatePreLog = "CreatePreLog",
  ViewPreLog = "ViewPreLog",
  ShowSecAdminLink = "ShowSecAdminLink",
  ViewVACORISNumber = "ViewVACORISNumber"
}
